import api from 'services/api'
import {
  GET_INVOICES_LIST,
  DELETE_INVOICE,
  CREATE_INVOICE,
  UPDATE_INVOICE,
  GET_INVOICE_DETAIL,
} from '../endpoints'

export const getInvoicesList = async (body) => await api.post(GET_INVOICES_LIST, body)
export const deleteInvoice = async (id) => await api.delete(DELETE_INVOICE, {data: {id}})

export const submitInvoice = async (body, id) =>
  await api.post(id ? UPDATE_INVOICE : CREATE_INVOICE, body)

export const getInvoiceDetail = async (invoice_id) =>
  await api.post(GET_INVOICE_DETAIL, {invoice_id})
